import { render, staticRenderFns } from "./AcceptPreregister.vue?vue&type=template&id=c5afb9f8&scoped=true"
import script from "./AcceptPreregister.vue?vue&type=script&lang=js"
export * from "./AcceptPreregister.vue?vue&type=script&lang=js"
import style0 from "./AcceptPreregister.vue?vue&type=style&index=0&id=c5afb9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5afb9f8",
  null
  
)

export default component.exports